exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag[data-v-bf3d33e8]{border:1px solid #e0e0e0;border-radius:3px;color:#858585;font-weight:400;font-size:1.1em;padding:0 .5ch;vertical-align:middle}.tag[invalid][data-v-bf3d33e8]{border:1px solid red}.hl-click[data-v-bf3d33e8]{width:10px;cursor:pointer}.hl-click[data-v-bf3d33e8]:hover:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-bf3d33e8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/tag.vue
// module id = 13
// module chunks = 0